import { render, staticRenderFns } from "./BanIcon.vue?vue&type=template&id=27586fda&"
import script from "./BanIcon.vue?vue&type=script&lang=js&"
export * from "./BanIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports